// GET /access/status — гейт подписки на канал (docs/backend.md §9, domain/channelGate.ts).
//
// Ручку фронт опрашивает фоновым запросом: пока доступ есть — приложение работает как обычно,
// как только бэк ответил `allowed: false` — фронт уводит на экран-заглушку и не выпускает,
// пока подписка не появится.
import { z } from 'zod'
import { CHANNEL_ACCESS_REASONS } from '../domain/channelGate.js'

export const channelAccessReasonSchema = z.enum(CHANNEL_ACCESS_REASONS)

export const accessStatusResponseSchema = z.object({
  /** Доступ к мини-аппе. false — фронт обязан увести на экран подписки. */
  allowed: z.boolean(),
  reason: channelAccessReasonSchema,
  /** Ссылка на канал для кнопки «Подписаться». null — канал не настроен или не публичный. */
  channel_url: z.string().nullable(),
  /** Когда заканчивается льготный период (ISO). null — гейт выключен. */
  grace_ends_at: z.string().nullable(),
})
export type AccessStatusResponse = z.infer<typeof accessStatusResponseSchema>
